export default __webpack_public_path__ + "static/media/onboarding_lowerdoodads.848ec987.png";